import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "lock"
};
import { reactive, ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { showLoadingToast, closeToast, showNotify } from 'vant';
import { matchMac, getMac } from '@/api/addLock';
import Bus from "@/utils/eventBus";
Bus.$on("qrChange", res => {
  if (res) {
    console.log(res);
    // const arr:string[] = res.split('#') || []
    // mac.value = arr.length ? arr[arr.length - 1] : '';
  }
});
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    let modelForm = reactive({
      lockId: "",
      lockMac: "",
      gatewayMac: "",
      addressName: "",
      floorNum: "",
      roomName: "",
      locIdx: "",
      lockState: ""
    });
    // 获取锁具信息
    const refreshLoading = ref(false);
    const getMacInfo = (lockMac = modelForm.lockMac) => {
      console.log('getMacInfo', lockMac);
      refreshLoading.value = true;
      showLoadingToast({
        message: '刷新中...',
        forbidClick: true
      });
      getMac(lockMac).then(({
        code,
        msg,
        data
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: '刷新成功'
          });
          resetForm(data);
        }
      }).finally(() => {
        refreshLoading.value = false;
        closeToast();
      });
    };
    const route = useRoute();
    watch(() => route.query, obj => {
      obj.lockMac && getMacInfo(obj.lockMac);
    }, {
      immediate: true
    });
    // const matchText = computed(() => modelForm.lockState === "Y" ? "是" : "否");
    const isMacth = computed(() => modelForm.lockState === "Y");
    // 配对操作
    const loading = ref(false);
    const onSubmit = values => {
      console.log("submit", modelForm.lockId);
      loading.value = true;
      matchMac({
        lockId: modelForm.lockId
      }).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: "操作成功，自行刷新此页面查询配对结果"
          });
          // getMacInfo()
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    // 赋值操作
    const resetForm = obj => {
      var _obj$lockId, _obj$lockMac, _obj$gatewayMac, _obj$addressName, _obj$floorNum, _obj$roomName, _obj$locIdx, _obj$lockState;
      modelForm.lockId = (_obj$lockId = obj.lockId) !== null && _obj$lockId !== void 0 ? _obj$lockId : '';
      modelForm.lockMac = (_obj$lockMac = obj.lockMac) !== null && _obj$lockMac !== void 0 ? _obj$lockMac : '';
      modelForm.gatewayMac = (_obj$gatewayMac = obj.gatewayMac) !== null && _obj$gatewayMac !== void 0 ? _obj$gatewayMac : '';
      modelForm.addressName = (_obj$addressName = obj.addressName) !== null && _obj$addressName !== void 0 ? _obj$addressName : '';
      modelForm.floorNum = (_obj$floorNum = obj.floorNum) !== null && _obj$floorNum !== void 0 ? _obj$floorNum : '';
      modelForm.roomName = (_obj$roomName = obj.roomName) !== null && _obj$roomName !== void 0 ? _obj$roomName : '';
      modelForm.locIdx = (_obj$locIdx = obj.locIdx) !== null && _obj$locIdx !== void 0 ? _obj$locIdx : '';
      modelForm.lockState = (_obj$lockState = obj.lockState) !== null && _obj$lockState !== void 0 ? _obj$lockState : '';
    };
    return (_ctx, _cache) => {
      const _component_NavBar = _resolveComponent("NavBar");
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_van_floating_bubble = _resolveComponent("van-floating-bubble");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
        title: "锁具配对"
      }), _createVNode(_component_van_pull_refresh, {
        modelValue: refreshLoading.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => refreshLoading.value = $event),
        onRefresh: getMacInfo
      }, {
        default: _withCtx(() => [_createVNode(_component_van_form, {
          ref: "formRef",
          onSubmit: onSubmit
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: _unref(modelForm).lockState,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(modelForm).lockState = $event),
              required: "",
              readonly: "",
              "label-width": "200px",
              "input-align": "right",
              "error-message-align": "right",
              label: "是否配对",
              name: "lockState"
            }, {
              input: _withCtx(() => [_unref(modelForm).lockState == 'Y' ? (_openBlock(), _createBlock(_component_van_tag, {
                key: 0,
                type: "success",
                size: "large"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("是")])),
                _: 1
              })) : (_openBlock(), _createBlock(_component_van_tag, {
                key: 1,
                type: "danger",
                size: "large"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("否")])),
                _: 1
              }))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).lockMac,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(modelForm).lockMac = $event),
              required: "",
              readonly: "",
              "label-width": "200px",
              "input-align": "right",
              "error-message-align": "right",
              label: "门锁MAC",
              name: "lockMac"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).gatewayMac,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(modelForm).gatewayMac = $event),
              required: "",
              readonly: "",
              "label-width": "200px",
              "input-align": "right",
              "error-message-align": "right",
              label: "网关MAC",
              name: "gatewayMac"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).addressName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(modelForm).addressName = $event),
              required: "",
              readonly: "",
              "label-width": "100px",
              "input-align": "right",
              "error-message-align": "right",
              label: "楼栋",
              name: "addressName"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).floorNum,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(modelForm).floorNum = $event),
              required: "",
              readonly: "",
              "label-width": "100px",
              "input-align": "right",
              "error-message-align": "right",
              label: "楼层",
              name: "floorNum"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).roomName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(modelForm).roomName = $event),
              required: "",
              readonly: "",
              "label-width": "100px",
              "input-align": "right",
              "error-message-align": "right",
              label: "房间",
              name: "roomName"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: _unref(modelForm).locIdx,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(modelForm).locIdx = $event),
              required: "",
              readonly: "",
              "label-width": "100px",
              "input-align": "right",
              "error-message-align": "right",
              label: "位号",
              name: "locIdx"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _unref(modelForm).lockState != 'Y' ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            class: "submit",
            block: "",
            loading: loading.value,
            "loading-text": "配对中...",
            disabled: loading.value,
            type: "success",
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 配对 ")])),
            _: 1
          }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_floating_bubble, {
        icon: "replay",
        axis: "xy",
        onClick: getMacInfo
      })]);
    };
  }
});